"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserInfoSearchModel = instanceOfUserInfoSearchModel;
exports.UserInfoSearchModelFromJSON = UserInfoSearchModelFromJSON;
exports.UserInfoSearchModelFromJSONTyped = UserInfoSearchModelFromJSONTyped;
exports.UserInfoSearchModelToJSON = UserInfoSearchModelToJSON;
exports.UserInfoSearchModelToJSONTyped = UserInfoSearchModelToJSONTyped;
/**
 * Check if a given object implements the UserInfoSearchModel interface.
 */
function instanceOfUserInfoSearchModel(value) {
    return true;
}
function UserInfoSearchModelFromJSON(json) {
    return UserInfoSearchModelFromJSONTyped(json, false);
}
function UserInfoSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'userAccount': json['userAccount'] == null ? undefined : json['userAccount'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'orgGroup': json['orgGroup'] == null ? undefined : json['orgGroup'],
        'orgName': json['orgName'] == null ? undefined : json['orgName'],
        'isStop': json['isStop'] == null ? undefined : json['isStop'],
    };
}
function UserInfoSearchModelToJSON(json) {
    return UserInfoSearchModelToJSONTyped(json, false);
}
function UserInfoSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'userAccount': value['userAccount'],
        'userName': value['userName'],
        'orgGroup': value['orgGroup'],
        'orgName': value['orgName'],
        'isStop': value['isStop'],
    };
}
